import { immutableReplace } from '../../lib/arrayOperations'

import {
    APP_SET_SEARCH,
    APP_UPDATE_ATTRIBUTE,
    HANDLE_CHANGE,
    SET_USER_ATTRIBUTES,
    SET_USER_DATA,
    SHOW_UPDATE_ATTRIBUTES,
    SHOW_BUILDING_PICKER,
    UPDATE_TRAINING_RESULT,
    UPDATE_WINDOW_DIMENSIONS,
    UPDATE_BUILDING_DATA,
    APP_TOGGLE_ADMIN_MODE,
    UPDATE_USER_DATA,
    UPDATE_TENANT_DATA,
    SET_USER_OCCUPANCIES,
    SET_ADMIN_STATUS,
    APP_SHOW_ERROR_PAGE,
    APP_SET_PLAYLISTS,
    APP_SET_PROPERTY_PLAYLISTS,
    UPDATE_USER_ROLES,
    SET_TRAINING_RESULTS,
    APP_SET_LOADING,
    APP_TEAM_MEMBERSHIP_DECLINED,
    APP_TEAM_MEMBERSHIP_ACCEPTED,
    APP_SET_TEAM_PROGRAMS,
        SET_TERMS_ACCEPTED,
    SHOW_TERMS_OF_USE
} from '../actionTypes'
import { mergeTeamPrograms, removeTeamPrograms } from '../../lib/teamPrograms'

const defaultState = {
    errorMsg: null,
    isLoading: true,
    isAdmin: false,
    adminMode: false,
    building: {},
    property: {},
    tenant: {},
    client: {},
    user: {
        attributes: {},
        userGroups: {},
    },
    floorWardens: null,
    search: null,
    showUpdateAttributes: false,
    showBuildingPicker: false,
    height: 0,
    width: 0,
    occupancies: [],
    playlists: [],
    propertyPlaylists: null,
    termsAccepted: false,
    showTermsOfUse: false,
    // Programs assigned by the user's team positions (lib/teamPrograms
    // entries). null until getProgramData resolves them.
    teamPrograms: null,
}

const appReducer = (state = defaultState, action) => {
    switch (action.type) {
        case APP_SET_LOADING:
            return {
                ...state,
                isLoading: action.value
            }
        case SET_ADMIN_STATUS:
            return {
                ...state,
                isAdmin: action.admin,
            }
        case APP_SET_SEARCH:
            return {
                ...state,
                search: action.value,
            }

        case APP_UPDATE_ATTRIBUTE:
            return {
                ...state,
                user: {
                    ...state.user,
                    attributes: {
                        ...state.user.attributes,
                        [action.attr]: action.val,
                    },
                },
            }

        case HANDLE_CHANGE:
            return { ...state, [action.name]: action.event.target.value }

        case SET_USER_ATTRIBUTES:
            return {
                ...state,
                user: {
                    attributes: action.data,
                    userGroups: action.user.signInUserSession.idToken.payload['cognito:groups'],
                },
                adminMode: action.admin,
            }

        case SET_USER_DATA: {
            // Once this occupant record has confirmed their information in
            // this session (haveLoggedIn re-asserted by UserConfigurator), a
            // re-dispatch for the same record must not regress the flag — a
            // stale/eventually-consistent getOccupancy read would otherwise
            // re-arm the first-login CONFIRM USER INFORMATION popup.
            const sameOccupant =
                state.user?.sk === action.data.sk && state.user?.d2 === action.data.d2
            const haveLoggedIn =
                (sameOccupant && state.user?.haveLoggedIn === true) || action.data.haveLoggedIn
            return {
                ...state,
                building: action.data.building,
                property: action.data.property,
                tenant: action.data.tenant,
                client: action.data.client,
                user: {
                    ...state.user,
                    userId: action.data.userId,
                    userD1: action.data.d1,
                    d2: action.data.d2,
                    sk: action.data.sk,
                    firstName: action.data.firstName,
                    lastName: action.data.lastName,
                    workPhone: action.data.workPhone,
                    phoneNumber: action.data.phoneNumber,
                    floor: action.data.floor,
                    floorWarden: action.data.floorWarden,
                    roles: action.data.roles,
                    suite: action.data.suite,
                    version: action.data.version,
                    email: action.data.email,
                    extraFields: action.data.extraFields,
                    haveLoggedIn,
                    termsAcceptanceDate: action.data.termsAcceptanceDate
                },
                teamMember: action.data.teamMember,
                isLoading: false,
            }
        }

        case SHOW_UPDATE_ATTRIBUTES:
            return { ...state, showUpdateAttributes: action.show }

        case SET_TRAINING_RESULTS:
            return {
                ...state,
                trainingResults: action.trainingResults
            }
        case UPDATE_TRAINING_RESULT:

            return {
                ...state,
                trainingResults: [
                    ...state.trainingResults.filter((result) => result.sk.split('#')[1] !== action.newResult.sk.split('#')[1]),
                    {
                        ...action.newResult
                    },
                ],
            }

        case UPDATE_WINDOW_DIMENSIONS:
            return {
                ...state,
                width: action.width,
                height: action.height,
            }

        case UPDATE_BUILDING_DATA: {
            // The updateBuilding mutation only selects part of settings, so a
            // shallow merge would wipe the keys it doesn't return (positions,
            // suites, phoneNumbers, half of systemConfig, ...). Deep-merge the
            // settings so a Tools toggle updates modules live without
            // corrupting the rest of the building state.
            const incoming = action.data || {}
            const prevSettings = state.building?.settings
            const settings = incoming.settings
                ? {
                    ...prevSettings,
                    ...incoming.settings,
                    systemConfig: incoming.settings.systemConfig
                        ? { ...prevSettings?.systemConfig, ...incoming.settings.systemConfig }
                        : prevSettings?.systemConfig,
                }
                : prevSettings
            return {
                ...state,
                building: {
                    ...state.building,
                    ...incoming,
                    settings,
                },
            }
        }
        case UPDATE_TENANT_DATA:
            return {
                ...state,
                tenant: {
                    ...state.tenant,
                    ...action.data,
                },
            }

        case SHOW_BUILDING_PICKER:
            return {
                ...state,
                showBuildingPicker: action.show,
            }

        case SET_USER_OCCUPANCIES:
            return {
                ...state,
                occupancies: action.data
            }

        case APP_TOGGLE_ADMIN_MODE: {
            return {
                ...state,
                adminMode: !state.adminMode,
                localMode: action.localStatus,
            }
        }

        case UPDATE_USER_DATA: {
            return {
                ...state,
                user: {
                    ...state.user,
                    ...action.data,
                    floor: action.data.d1.split("#")[5],
                    suite: action.data.d1.split("#")[6]
                },
            }
        }
        case UPDATE_USER_ROLES: {
            return {
                ...state,
                user: {
                    ...state.user,
                    roles: action.roles,
                },
            }
        }
        case APP_SHOW_ERROR_PAGE:
            return {
                ...state,
                showErrorPage: action.show,
            }
        case APP_SET_PLAYLISTS:
            return {
                ...state,
                playlists: action.playlists,
            }
        case APP_SET_PROPERTY_PLAYLISTS:
            return {
                ...state,
                propertyPlaylists: action.playlists,
            }
        case SET_TERMS_ACCEPTED:
            return {
                ...state,
                termsAccepted: action.payload
            }

        case SHOW_TERMS_OF_USE:
            return {
                ...state,
                showTermsOfUse: action.payload
            }
        case APP_SET_TEAM_PROGRAMS:
            return {
                ...state,
                teamPrograms: Array.isArray(action.entries) ? action.entries : [],
            }
        case APP_TEAM_MEMBERSHIP_ACCEPTED: {
            const merged = new Set([
                ...(state.user?.roles || []),
                ...(action.rolesAdded || []),
            ])
            // Stamp acceptedOn on the stored membership (when identified) so
            // the assignment acceptor never re-queues an accepted assignment.
            const teamMember = action.pk && action.sk
                ? (state.teamMember || []).map((m) =>
                    m.pk === action.pk && m.sk === action.sk
                        ? { ...m, acceptedOn: action.acceptedOn || Date.now() }
                        : m
                )
                : state.teamMember
            return {
                ...state,
                teamMember,
                teamPrograms: mergeTeamPrograms(state.teamPrograms, action.programsAdded),
                user: {
                    ...state.user,
                    roles: [...merged],
                },
            }
        }
        case APP_TEAM_MEMBERSHIP_DECLINED:
            const { pk, sk, rolesRemoved } = action
            const removed = new Set(rolesRemoved)

            return {
                ...state,
                teamMember: (state.teamMember || []).filter(
                    (m) => !(m.pk === pk && m.sk === sk)
                ),
                teamPrograms: removeTeamPrograms(state.teamPrograms, pk),
                user: {
                    ...state.user,
                    roles: (state.user?.roles || []).filter((r) => !removed.has(r)),
                },
            }
        default:
            return state
    }
}

export default appReducer
